import { useMemo } from "react";
import { Link } from "react-router-dom";
import { badgeContrato, derivarStageExibicao, diasParado, STAGES } from "../lib/stages";
import type { BoardRow } from "../lib/types";
import { BotaoLinkAssinatura } from "./BotaoLinkAssinatura";
import styles from "./BoardKanban.module.css";

export function BoardKanban({ rows, mostrarValor }: { rows: BoardRow[]; mostrarValor: boolean }) {
  const colunas = useMemo(() => {
    const map = new Map<number, BoardRow[]>();
    for (const s of STAGES) map.set(s.n, []);
    for (const r of rows) {
      const st = derivarStageExibicao(r);
      map.get(st)?.push(r);
    }
    return map;
  }, [rows]);

  return (
    <div className={styles.board}>
      {STAGES.map((s) => {
        const cards = colunas.get(s.n) ?? [];
        return (
          <section key={s.n} className={styles.col}>
            <header className={styles.colHead}>
              <span className={styles.colNum}>{s.n}</span>
              <span className={styles.colLabel}>{s.label}</span>
              <span className={styles.colCount}>{cards.length}</span>
            </header>
            <div className={styles.colBody}>
              {cards.map((r) => (
                <CardCliente key={r.cliente_id} row={r} mostrarValor={mostrarValor} />
              ))}
              {cards.length === 0 && <p className={styles.vazio}>—</p>}
            </div>
          </section>
        );
      })}
    </div>
  );
}

function CardCliente({ row, mostrarValor }: { row: BoardRow; mostrarValor: boolean }) {
  const badge = badgeContrato(row.contrato_status, row.contrato_confirmado_em);
  const dias = diasParado(row.atualizado_em);
  return (
    <Link to={`/clientes/${row.cliente_id}`} className={styles.card}>
      <div className={styles.cardNome}>{row.nome_projeto ?? row.cliente_nome ?? "Sem nome"}</div>
      <div className={styles.cardMeta}>
        <span className={`badge badge-${badge.tone}`}>{badge.label}</span>
        {row.n_contratos > 1 && <span className="badge badge-neutral">{row.n_contratos} contratos</span>}
        {row.modelo_contrato && <span className="dim mono">{row.modelo_contrato}</span>}
      </div>
      <div className={styles.cardFoot}>
        {mostrarValor && row.valor_mensal_numero != null && (
          <span className="muted">R$ {Number(row.valor_mensal_numero).toLocaleString("pt-BR")}/mês</span>
        )}
        {dias != null && dias >= 7 && (
          <span className={styles.parado} title="Dias sem atualização">{dias}d parado</span>
        )}
      </div>
      {row.d4sign_document_uuid && (row.contrato_status === "aguardando_assinatura" || row.contrato_status === "em_revisao_interna") && (
        <div style={{ marginTop: 6 }}>
          <BotaoLinkAssinatura doc={row.d4sign_document_uuid} clientNome={row.cliente_nome} compacto />
        </div>
      )}
    </Link>
  );
}
